import sptk from '../../libs/sptk.js';

export default class Expand {
    constructor(props) {
        this.props = props;

        this.isOpen = false;

        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();

        this.storeSizes();

        this.setAria({
            label: 'Ouvrir'
        });

        this.updateHeight();

        this.checkInitialState();
    }

    bindUI() {
        this.ui = {};

        this.ui.expandInner = this.props.el.querySelector('.js-expand-inner');
        this.ui.expandBtn = this.props.el.querySelector('.js-expand-btn');
        this.ui.expandContent = this.props.el.querySelector('.js-expand-content');
    }

    bindEvents() {
        this.props.el.addEventListener('shouldUpdateHeight', this.onUpdateHeight.bind(this));
        document.body.addEventListener('shouldCloseOthers', this.onCloseOthers.bind(this));

        this.ui.expandBtn.addEventListener('click', this.onClick.bind(this));
    }

    checkInitialState() {
        if (this.props.el.classList.contains('is-open')) {
            this.open();
        }
    }

    onUpdateHeight(e) {
        const updateDetails = e.detail;

        if (updateDetails.direction == 'open') {
            this.sizes.deployedHeight += updateDetails.heightToAdd;
        } else {
            this.sizes.deployedHeight -= updateDetails.heightToAdd;
        }

        this.updateHeight();
    }

    onCloseOthers(e) {
        const closeDetails = e.detail;

        // Checking if its the correct sibling
        if (closeDetails.className === this.props.className) {
            // If it's not the one that is opening
            if (closeDetails.id != this.props.index) {
                // And if it is open
                if (this.isOpen) {
                    // Then we close it
                    this.close();
                }
            }
        }
    }

    update() {
        // Setting this in order to compute things right.
        this.ui.expandInner.style.height = 'auto';

        this.storeSizes();
        this.updateHeight();
    }

    destroy() {
        this.ui.expandBtn.removeEventListener('click', this.onClick.bind(this));

        this.sizes = {};
        this.isOpen = false;
    }

    storeSizes() {
        this.sizes = {
            offsetTop: this.props.el.getBoundingClientRect().top,
            height: this.props.el.clientHeight,
            deployedHeight: this.props.el.clientHeight + this.ui.expandContent.clientHeight
        };
    }

    onClick(e) {
        e.preventDefault();

        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }

        setTimeout(() => {
            this.triggerStateUpdate();
        }, 500);
    }

    open() {
        this.isOpen = true;

        this.ui.expandInner.style.height = `${this.sizes.deployedHeight}px`;
        this.props.el.classList.add('is-open');

        this.setAria({
            label: 'Fermer'
        });

        if (this.props.scrollTo) {
            sptk.utils.goTo(this.sizes.offsetTop, 240);
        }

        if (this.props.parent) {
            this.triggerParentUpdate('open');
        }

        if (this.props.closeOthers) {
            this.triggerSiblingsClosing();
        }

        this.triggerOpen();
    }

    close() {
        this.isOpen = false;

        this.ui.expandInner.style.height = `${this.sizes.height}px`;
        this.props.el.classList.remove('is-open');

        this.setAria({
            label: 'Ouvrir'
        });

        if (this.props.parent) {
            this.triggerParentUpdate('close');
        }

        this.triggerClose();
    }

    triggerSiblingsClosing() {
        const closeEvent = new CustomEvent('shouldCloseOthers', {
            detail: {
                id: this.props.index,
                className: this.props.className
            }
        });

        document.body.dispatchEvent(closeEvent);
    }

    triggerStateUpdate() {
        const updateEvent = new CustomEvent('expand:toggle');

        document.body.dispatchEvent(updateEvent);
    }

    triggerParentUpdate(direction) {
        const updateEvent = new CustomEvent('shouldUpdateHeight', {
            detail: {
                heightToAdd: this.ui.expandContent.clientHeight,
                direction
            }
        });

        this.props.parent.dispatchEvent(updateEvent);
    }

    triggerOpen() {
        const openEvent = new CustomEvent(`${this.props.namespace}:expand:open`, {
            detail: {
                index: this.props.index
            }
        });

        document.body.dispatchEvent(openEvent);
    }

    triggerClose() {
        const openEvent = new CustomEvent(`${this.props.namespace}:expand:close`, {
            detail: {
                index: this.props.index
            }
        });

        document.body.dispatchEvent(openEvent);
    }

    updateHeight() {
        if (this.isOpen) {
            this.ui.expandInner.style.height = `${this.sizes.deployedHeight}px`;
        } else {
            this.ui.expandInner.style.height = `${this.sizes.height}px`;
        }
    }

    setAria(props) {
        this.ui.expandBtn.setAttribute('aria-label', props.label);
        this.ui.expandBtn.setAttribute('tabindex', '-1');
    }
}
